/**
 * @file: planDetailEditable.ts
 *
 * One rule, shared by the feed reminder body and the plans timeline, for when
 * a maintenance-plan detail's edit menu (rename / dates / alerts / cancel) is
 * offered: only while the detail is still actionable — not yet turned into a
 * lead, and not past its next service date. The backend enforces only tenancy
 * on these edits, so this is a UX gate, not an authorization boundary.
 */

import { LeadCoverage } from '@euler/model/lead/Lead';
import { dateFromValue } from '@euler/utils/datetime';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import startOfToday from 'date-fns/startOfToday';

/** Next service date has passed (the reminder window has lapsed). */
export function isPlanDetailExpired(nextServiceDate: string | Date): boolean {
  return (
    differenceInCalendarDays(dateFromValue(nextServiceDate), startOfToday()) < 0
  );
}

/** Editable while still uncovered by a lead and not past its service date. */
export function canEditPlanDetail(detail: {
  leadCoverage: LeadCoverage;
  nextServiceDate: string | Date;
}): boolean {
  return (
    detail.leadCoverage === 'uncovered' &&
    !isPlanDetailExpired(detail.nextServiceDate)
  );
}
